import * as React from 'react'
import Navbar from '../Setup/Navbar'
import { Container, Grid2, Typography } from '@mui/material'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import AutoCompleteSelf from '../../BuiltInComponent/AutoComplete'
import { useDispatch, useSelector } from 'react-redux'
import { getBuyerNames, getBuyerWiseSalesData } from '../../features/Clients/sales/salesSlice'
import { useNavigate } from 'react-router-dom';
import RowRadioButtonsGroup from '../../BuiltInComponent/RadioButton';
import Loading from '../../BuiltInComponent/Loading'

export default function SalesReport() {

    const isMobile = useMediaQuery('(max-width:600px)')

    const dispatch = useDispatch()

    const { buyerNames, salesData, isLoading } = useSelector(state => state.sales)

    const [selectedValue, setSelectedValue] = React.useState('quantity');
    const [mhCode, setMHCode] = React.useState();
    // const [mrgItemCode, setMrgItemCode] = React.useState();


    React.useEffect(() => {
        dispatch(getBuyerNames())
    }, [dispatch])

    const arrayForButton = [
        { value: 'quantity', label: 'Quantity' },
        { value: 'kg', label: 'Quantity' },
        { value: 'lbs', label: 'LBS' },
    ]

    const handleChangeRadioButton = (rbValue) => {
        setSelectedValue(rbValue);
        console.log('Selected Value with Main Window :', rbValue);
        if (mhCode === '') {
            // dispatch(getBuyerWiseSalesData({ mhCode: mhCode, order: rbValue }))
        } else {
            dispatch(getBuyerWiseSalesData({ mhCode: mhCode, order: rbValue }))
        }
    };

    const onChange = (data) => {
        console.log(data)
        const keys = Object.keys(data)
        setMHCode(data[keys])
        // setMrgItemCode('')
        if (keys[0] === 'mhCode') {
            dispatch(getBuyerWiseSalesData({ mhCode: data[keys], order: selectedValue }))
        }
    }

    // const onChangeMergeItem = (data) => {
    //     const keys = Object.keys(data)
    //     console.log(keys)
    //     // setMHCode('')
    //     setMrgItemCode(data[keys])
    //     if (keys[0] === 'mrgItemCode') {
    //         // dispatch(getMergeItemData({ mrgItemCode: data[keys], order: selectedValue }))
    //     }
    // }

    return (
        <>
            <Navbar />
            <Container>
                <Grid2 container spacing={2}>
                    <Grid2 size={12}><Typography
                        sx={{
                            textAlign: 'center', fontSize: 35, fontWeight: 'bolder', backgroundColor: 'black',
                            color: 'white', borderRadius: 3, textShadow: 'grey 5px 5px 5px'
                        }}
                    >Sales Report</Typography></Grid2>
                    <Grid2 size={isMobile ? 12 : 4} display='flex' justifyContent='center'>
                        <RowRadioButtonsGroup
                            handleChangeRadioButton={handleChangeRadioButton}
                            selectedValue={selectedValue}
                            arrayForButton={arrayForButton} />
                    </Grid2>
                    <Grid2 size={isMobile ? 12 : 4}>
                        <AutoCompleteSelf
                            listData={buyerNames && buyerNames}
                            onChange={onChange}
                            label='Select Section Name'
                        />
                    </Grid2>
                    {/* <Grid2 size={isMobile ? 12 : 4}>
                        <AutoCompleteSelf
                            listData={mrgItemName && mrgItemName}
                            onChange={onChangeMergeItem}
                            label='Select Item Name'
                        />
                    </Grid2> */}
                    <Grid2 size={12}>
                        {isLoading ?
                            <Loading /> :
                            <StickyHeadTable
                                tableColumns={salesData.columns && salesData.columns}
                                tableData={salesData.rows && salesData.rows}
                                perPage={50} />
                        }
                    </Grid2>
                </Grid2>
            </Container>
        </>
    )
}


function StickyHeadTable(props) {

    const navigate = useNavigate()
    const theme = useTheme()

    const perPage = props.perPage
    const tableColumns = props.tableColumns
    const rows = props.tableData

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(perPage || 5);
    // const [filter, setFilter] = React.useState(''); // New state for filtering
    const [filteredRows, setFilteredRows] = React.useState(rows); // New state to hold filtered data

    // Handle pagination
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // Handle the filter input change
    // const handleFilterChange = (event) => {
    //     const filterValue = event.target.value.toLowerCase();
    //     // setFilter(filterValue);

    //     // Filter rows based on filter input
    //     const filteredData = rows.filter(row => {
    //         return tableColumns.some(col => {
    //             const cellValue = row[col.fieldName]?.toString().toLowerCase();
    //             return cellValue && cellValue.includes(filterValue);
    //         });
    //     });

    //     setFilteredRows(filteredData);
    // };

    React.useEffect(() => {
        setFilteredRows(rows); // Update filteredRows if rows change
    }, [rows]);

    return (
        <Paper sx={{ width: '98%', overflow: 'hidden', backgroundColor: 'rgb(250, 250, 250)' }}>
            {/* <Grid2 container spacing={1}>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    <TextField
                        sx={{ margin: '20px' }}
                        label="Filter"
                        variant="outlined"
                        fullWidth
                        value={filter}
                        onChange={handleFilterChange}
                        placeholder="Search by any column..."
                        size='small'
                    />
                </Grid2>
                <Grid2 size={4}></Grid2>
            </Grid2> */}
            <TableContainer >
                <Table stickyHeader aria-label="sticky table" size='small'>
                    <TableHead>
                        <TableRow>
                            {tableColumns && tableColumns.map((columns, index) => (
                                tableColumns[index].status === 'en' ?
                                    <>
                                        <TableCell
                                            key={index}
                                            style={{
                                                backgroundColor: theme.palette.primary.main,
                                                color: 'white',
                                                textAlign: `${tableColumns[index].textAlign}`,
                                                fontWeight: 'bolder',
                                                width: `${columns.width}`,
                                                textShadow: 'black 2px 2px 4px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {columns.cName}
                                        </TableCell>
                                    </> : <></>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredRows && filteredRows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, rowIndex) => {
                                return (
                                    <TableRow
                                        key={rowIndex}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        style={{ width: '70%', }}
                                    >
                                        {tableColumns.map((col, index) => (
                                            <TableCell
                                                key={index}
                                                style={{
                                                    textAlign: `${tableColumns[index].dType === 'number' ?
                                                        index === 0 ? 'center' : 'right' : 'left'}`,
                                                    fontWeight: `${rowIndex + page * rowsPerPage === filteredRows.length - 1 ? 'bolder' : ''}`,
                                                    // fontWeight: `${rowIndex === filteredRows.length - 1 ? 'bolder' : ''}`,
                                                    fontSize: rowIndex + page * rowsPerPage === rows.length - 1 ? 15 : 13,
                                                    width: tableColumns[index].width,
                                                    cursor: index === 0 ? 'pointer' : '',
                                                    whiteSpace: 'nowrap',
                                                }}
                                                component="th"
                                                scope="row"
                                                sx={{ border: 'ridge 1px' }}
                                                onClick={() => {
                                                    const itemCode = row.itemCode
                                                    console.log(itemCode)
                                                    navigate('/Stock/BuyerWiseStock', { state: { itemCode } })
                                                }}
                                            >
                                                {tableColumns[index].dType === 'number'
                                                    ? `${row[tableColumns[index].fieldName] ? Math.round(row[tableColumns[index].fieldName]).toLocaleString("en-US") : '0'}`
                                                    : row[tableColumns[index].fieldName] ? row[tableColumns[index].fieldName] : '0'}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[50, 100, 200]}
                component="div"
                count={filteredRows && filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}
